export default [
  {
    title: "Q1 2021",
    cardTitle:
      "Acquisition of Arabianchain Technologies by Basiqat Holding Group",
  },
  {
    title: "Q2 2021",
    cardTitle: "ArabianChain official team formation in Bahrain",
    cardDetailedText: "ArabianChain is headquartered in the Kingdom of Bahrain",
  },
  {
    title: "Q3 2021",
    cardTitle: "Agreement upon new business plan",
    cardDetailedText:
      "Board agreement on new blockchain platform, digitalcurrency and digital wallet",
  },
  {
    title: "Q1 2022",
    cardTitle: "Development of DUBXCOIN PROJECT",
    cardDetailedText: "DUBXCOIN-DUBX is under active development",
  },
  {
    title: "Q3 2022",
    cardTitle: "Swap plan",
    cardDetailedText: "Swap DBIX to DUBX",
  },
  {
    title: "Q4 2022",
    cardTitle: "DUBXCOIN",
    cardDetailedText: "New blockchain platform is released",
  },
  {
    title: "Q4 2022",
    cardTitle: "DUBX ecosystem",
  },
  {
    title: "Q2 2023",
    cardTitle: "Galaxy wallet V1",
  },
  {
    title: "Q2 2023",
    cardTitle: "Listing of Dubx",
  },
  {
    title: "Q3 2023",
    cardTitle: "R&D lab setup",
  },
  {
    title: "Q2 2024",
    cardTitle: "Islamic Banking on Blockchain",
    cardDetailedText:
      "The first Islamic Banking products focusing on consumer loans running on the Arabianchain network",
  },
  {
    title: "Q3 2024",
    cardTitle: "ArabianChain Studio V1",
    cardDetailedText:
      "Adding new features such as, predefined templates, cloud storage and sharing",
  },
  {
    title: "Q4 2024",
    cardTitle: "Thuraya A.I",
    cardDetailedText:
      "An artificial intelligence chatbot allowing users to create smart contracts using natural language conversations.",
  },
  {
    title: "Q3 2025",
    cardTitle: "First release of ArabianChain SDK",
    cardDetailedText:
      "A standard development kit allowing developers to create and manage private blockchains.",
  },
  {
    title: "Q4 2025",
    cardTitle: "ArabianChain Academy",
  },
  {
    title: "Q4 2025",
    cardTitle: "Permissioned Business Blockchain",
    cardDetailedText:
      "A business blockchain framework for developing blockchain applications or solutions with a modular architecture.",
  },
];
